<mat-card class="charts-container">
  <mat-card class="chart-card">
    <mat-card-header>
        <mat-card-title>Daily Execution Volume</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <ngx-charts-bar-vertical-stacked
        #dailyExecutionChart
        [yScaleMax]="maxExecutions"
        [scheme]="customColorScheme"
        [results]="chartDataVolume"
        [gradient]="false"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="false"
        [showXAxisLabel]="true"
        [showYAxisLabel]="true"
        xAxisLabel="Date"
        yAxisLabel="Executions"
        >
        </ngx-charts-bar-vertical-stacked>
    </mat-card-content>
  </mat-card>

    <mat-divider></mat-divider>

    <mat-card class="chart-card">
    <mat-card-header>
        <mat-card-title>Failure Rate</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <ngx-charts-line-chart
        [yScaleMax]="maxFailureRate"
        [scheme]="colorScheme"
        [results]="chartDataRate"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="false"
        [showXAxisLabel]="true"
        [showYAxisLabel]="true"
        xAxisLabel="Date"
        yAxisLabel="Error (%)"
        >
        </ngx-charts-line-chart>
    </mat-card-content>
  </mat-card>
</mat-card>